<app-user-dashboard>
  <div class="card">
    <div class="header-card separator pt-0">
      <div class="w-3 container-title">
        <h1 class="text-xl font-medium text-800 my-0">{{'UserFormatPalletStock.FormatTitle' | translate}}</h1>
      </div>
      <div class="w-9 flex align-items-center justify-content-end flex-wrap gap-2">
        <p-button 
          label="{{'UserFormatPalletStock.CreateFormatBtn' | translate}}" 
          icon="pi pi-plus" 
          class="custom-text-button"
          (click)="onVisibleCreateStock()">
        </p-button>
        <p-button 
          label="{{'UserFormatPalletStock.CreateFormatFromFile' | translate}}" 
          icon="pi pi-file" 
          styleClass="p-button-secondary" 
          class="custom-text-button"
          (click)="onVisibleCreateFileFormat()">
        </p-button>
      </div>
    </div>
    <div class="body-card pt-3">
      <p-table
        [value]="formatPalletStock"
        [paginator]="true"
        class="custom-table"
        [rows]="5"
        [loading]="loading"
      >
        <ng-template pTemplate="header" >
          <tr>
            <th>
              <div class="flex justify-content-center">
                {{'UserFormatPalletStock.NameColumn' | translate}}
              </div>
            </th>
            <th>
              <div class="flex justify-content-center">
                {{'UserFormatPalletStock.ActionsColumn' | translate}}
              </div>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-format>
          <tr>
            <td>
              <div class="flex justify-content-center">
                {{format.name}}
              </div>
            </td>
            <td>
              <div class="flex justify-content-center">
                <p-button 
                  icon="pi pi-file-edit"
                  pTooltip="{{'UserPalletStock.EditStock' | translate}}"
                  tooltipPosition="bottom"
                  class="custom-button-icon purple-btn"
                  (click)="onEditFormat(format.id, format.name)">
                </p-button>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

<p-dialog 
  header="" 
  [(visible)]="visibleCreateFormatPalletStock"
  [style]="{width: '80vw', height: '90vh'}"
  class="stock-dialog"
  [modal]="true"
  [resizable]="true"
  [draggable]="false">
  
  <ng-template pTemplate="header">
    <div class="flex flex-row align-items-center gap-3">
      <span class="text-xl font-bold">{{'UserPalletStock.CreateFormatTitle' | translate}}</span>
      <div *ngIf="stockFile">
        <i class="pi pi-info-circle text-blue-600 cursor-pointer" 
          (click)="instructionsOverlay.toggle($event)"
          pTooltip="{{'UserPalletStock.ClickHereInfoText' | translate}}"></i>
        <p-overlayPanel #instructionsOverlay>
          <ng-template pTemplate="content">
            <div class="flex flex-column text-sm text-justify">
              <span><strong>*</strong> {{'UserPalletStock.SelectColumnInfoText' | translate}}</span>
              <span><strong>*</strong> {{'UserPalletStock.EmptyColumnInfoText' | translate}}</span>
            </div>
          </ng-template>
        </p-overlayPanel>
      </div>
    </div>
  </ng-template>
  
  <div *ngIf="visibleCreateFormatPalletStock">
    <app-create-pallet-stock-format [headers]="headers"
      (OnCancelCreate)="onCancelFormat()"
      (OnCreateFormat)="onSaveFormat()"
      [formatId]="selectedFormat"
      [formatName]="selectedFormatName"
      [file]="stockFile"
    >
    </app-create-pallet-stock-format>
  </div>
</p-dialog>

  <p-dialog header="{{'UserPalletStock.CreateFormatTitle' | translate}}" 
    [(visible)]="visibleFileFormat" 
    [style]="{width: '50%'}" 
    [modal]="true"
    (onHide)="onCloseFileFormat()">
      <div class="field col-12" style="margin-bottom: 40px;">
        <label class="text-sm line-height-2">
          {{'UserPages.UserExportOfferDocument.Form.LoadDocumentInstructionsLabel' | translate}}
        </label>
        <p-fileUpload
          #documentFileUploader
          (onSelect)="onSelectDocumentFile($event)"
          (onClear)="onClearDocumentFile()"
          (onRemove)="onClearDocumentFile()"
          [showUploadButton]="false"
          [multiple]="false"
          accept=".xlsx"
          [maxFileSize]="fileMaxSize"
          [showCancelButton]="false"
          [files]="stockFile ? [stockFile] : []"
          class="file-uploader"
          [chooseLabel]="stockFile ? 
            ('UserPages.UserExportOfferDocument.Form.EditFile' | translate) : 
            ('UserPages.UserExportOfferDocument.Form.SelectFile' | translate)
          ">
          <ng-template let-file pTemplate="file">
            <div class="flex flex-row justify-content-between align-content-center align-items-center">
              <span>{{ file.name }}</span>
              <span>{{ file.size | number }} KB</span>
              <p-button
                label="{{'UserPalletStock.RemoveButtonLabel' | translate}}"
                icon="pi pi-times"
                class="custom-text-button danger-filled"
                (onClick)="documentFileUploader.remove(file, 0)"
              />
            </div>
          </ng-template>
        </p-fileUpload>
      </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-content-end col-12">
        <p-button 
          label="{{'UserPages.UserExportOfferDocument.Form.CancelButtonLabel' | translate}}" 
          (onClick)="onCloseFileFormat()" 
          styleClass="p-button-outlined"
          class="custom-text-button form-button"/>
        <p-button 
          label="{{'UserPalletStock.CreateFormatFromFile' | translate}}"
          (onClick)="loadFormatFromExcel()"
          class="custom-text-button form-button"/>
      </div>
  </ng-template>
</p-dialog>
</app-user-dashboard>
